import React from 'react'
import CoursesList from '../components/MyCourses/CoursesList/CoursesList'

function myCourses(user) {
  return (
    <CoursesList user={user} />
  )
}

export default myCourses 